import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgJobPerLinkIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="job_per_link_svg__nc-icon-wrapper">
      <path data-color="color-2" d="M45 1.586V13h11.414z" />
      <path d="M44 15a1 1 0 0 1-1-1V1H9a2 2 0 0 0-2 2v58a2 2 0 0 0 2 2h46a2 2 0 0 0 2-2V15H44zm-8.464 26.192-2.828 2.828c-3.509 3.509-9.219 3.509-12.728 0-3.509-3.509-3.509-9.219 0-12.728l2.828-2.828c3.509-3.509 9.219-3.509 12.728 0a8.944 8.944 0 0 1 2.448 4.565c-.564.461-1.2.781-1.872.955a6.958 6.958 0 0 0-1.99-4.105c-2.729-2.729-7.171-2.729-9.899 0l-2.828 2.828a7.008 7.008 0 0 0 0 9.899 7.008 7.008 0 0 0 9.899 0l2.498-2.498c.908.085 1.823.046 2.725-.094-.292.412-.613.81-.981 1.178zm8.485-8.485-2.828 2.828c-3.509 3.509-9.219 3.509-12.728 0a8.944 8.944 0 0 1-2.448-4.565 4.887 4.887 0 0 1 1.872-.955 6.958 6.958 0 0 0 1.99 4.105 7.008 7.008 0 0 0 9.899 0l2.828-2.828c2.729-2.729 2.729-7.17 0-9.9-2.729-2.729-7.171-2.729-9.9 0l-2.498 2.498a11.053 11.053 0 0 0-2.725.094c.291-.412.612-.81.981-1.178l2.828-2.828c3.509-3.509 9.219-3.509 12.728 0 3.51 3.51 3.51 9.22.001 12.729z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgJobPerLinkStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgJobPerLinkIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const JobPerLinkIcon: any = SvgJobPerLinkStyle;
export default JobPerLinkIcon;
